import { render, staticRenderFns } from "./FilesListTableFooter.vue?vue&type=template&id=378a6e4a&scoped=true"
import script from "./FilesListTableFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilesListTableFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilesListTableFooter.vue?vue&type=style&index=0&id=378a6e4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378a6e4a",
  null
  
)

export default component.exports